exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-scroll .ui-table.ui-widget,\n.table-scroll .ui-table-scrollable-wrapper,\n.table-scroll .ui-table-scrollable-view\n{\n    height: 100%;\n}\n\n/* we must use !important to override inline styles placed by primeng js */\n\n.table-scroll .ui-table-scrollable-body {\n    /* 29px is height of table header here, adjust for your individual application */\n    height: calc(100% - 29px) !important;\n    max-height: none !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/app-table/app-table.component.css
// module id = ../../../../../angular/app/components/app-table/app-table.component.css
// module chunks = main